import DataService from '../../services/DataService'

const state = () => ({
    datas: [],
    data_campanha: null,
    data_material: null,
    data_pos: null,
    evento_limite: null,
    evento_total_limite: null,
    dataLoading: false,
    showModalDataCampanha: false,
    showModalDataMaterial: false,
    showModalDataPos: false,
})
  
const mutations = {
    SET_DATAS: (state, payload) => {
        state.datas = payload;
        state.data_campanha = payload.filter(item => item.name === 'Campanha')[0];
        state.data_material = payload.filter(item => item.name === 'Materiais')[0];
        state.data_pos = payload.filter(item => item.name === 'Pos')[0];
    },
    SET_DATAS_LOADING: (state, payload) => {
        state.dataLoading = payload;
    },
    SET_SHOW_MODAL_DT_CAMPANHA: (state, payload) => {
        state.showModalDataCampanha = payload;
    },
    SET_SHOW_MODAL_DT_MATERIAL: (state, payload) => {
        state.showModalDataMaterial = payload;
    },
    SET_SHOW_MODAL_DT_POS: (state, payload) => {
        state.showModalDataPos = payload;
    },
    SET_EVENTO_LIMITE: (state, payload) => {
        state.evento_limite = payload;
    },
    SET_EVENTO_TOTAL_LIMITE: (state, payload) => {
        state.evento_total_limite = payload;
    },
}

const actions = {
    async fetchDates({commit}){
        try{
            commit('SET_DATAS_LOADING', true)
            const response = await DataService.get_datas();
            commit('SET_DATAS', response.data)
            commit('SET_DATAS_LOADING', false)
        } catch (error) {
            commit('SET_DATAS_LOADING', false);
            // commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async registerDataCampanha({commit}, data){
        try{
            commit('SET_DATAS_LOADING', true);
            const response = await DataService.update_dtCampanha(data);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            commit('SET_DATAS_LOADING', false);
            return true;
        }catch(error){
            commit('SET_DATAS_LOADING', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
            return false;
        }
    },
    async registerDataMaterial({commit}, data){
        try{
            commit('SET_DATAS_LOADING', true);
            const response = await DataService.update_dtMaterial(data);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            commit('SET_DATAS_LOADING', false);
            return true;
        }catch(error){
            commit('SET_DATAS_LOADING', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
            return false;
        }
    },
    async registerDataPos({commit}, data){
        try{
            commit('SET_DATAS_LOADING', true);
            const response = await DataService.update_dtPos(data);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            commit('SET_DATAS_LOADING', false);
            return true;
        }catch(error){
            commit('SET_DATAS_LOADING', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
            return false;
        }
    },
    async fetchEventoLimite({commit}){
        try{
            const response = await DataService.get_evento_limite();
            commit('SET_EVENTO_LIMITE', response.data);
        } catch (error) {
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.message || 'Erro ao buscar limite'
            });
        }
    },
    async fetchEventoTotalLimite({commit}){
        try{
            const response = await DataService.get_evento_total_limite();
            commit('SET_EVENTO_TOTAL_LIMITE', response.data);
        } catch (error) {
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.message || 'Erro ao buscar limite total'
            });
        }
    },
}

const getters = {
    getDatas: state => state.datas,
    getDataCampanha: state => state.data_campanha,
    getDataMaterial: state => state.data_material,
    getDataPos: state => state.data_pos,
    getDataLoading: state => state.dataLoading,
    getShowModalDataCampanha: state => state.showModalDataCampanha,
    getshowModalDataMaterial: state => state.showModalDataMaterial,
    getshowModalDataPos: state => state.showModalDataPos,
    getEventoLimite: state => state.evento_limite,
    getEventoTotalLimite: state => state.evento_total_limite,
}

export default {
    state,
    getters,
    mutations,
    actions
};